<div class="phx-document-viewer">
  <div class="phx-document-viewer-view-container" (contextmenu)="onContextMenu($event)"
    (wheel)="onMouseWheel($event)" (touchstart)="onTouchStart($event)"
    (touchmove)="onTouchMove($event)" (touchend)="onTouchEnd($event)">
    <phx-spinner *ngIf="isLoading" [phxCentered]="true"></phx-spinner>
    <ng-container
      *ngTemplateOutlet="selectedFile && !selectedFile?.error ? selectedFileView : emptyFileView"></ng-container>

    <ng-template #selectedFileView>
      <div class="phx-document-viewer-image-view" *ngIf="isImageSelected"
        [class.phx-document-viewer-obfuscate]="phxObfuscate">
        <div class="phx-document-viewer-image-view-inner-container">
          <phx-image-pan-zoom #phxImagePanZoom [phxImageSrcUrl]="selectedFile?.url"
            [phxFitToContainer]="true"></phx-image-pan-zoom>
        </div>
      </div>
      <div class="phx-document-viewer-pdf-view" *ngIf="!isImageSelected"
        [class.phx-document-viewer-obfuscate]="phxObfuscate">
        <pdf-viewer [src]="selectedFile?.url" [render-text]="true" [original-size]="true" [autoresize]="true"
          [fit-to-page]="true" [zoom]="pdfZoom" [rotation]="pdfRotation"
          (after-load-complete)="afterLoadComplete($event)"></pdf-viewer>
      </div>
    </ng-template>
    <ng-template #emptyFileView>
      <div class="phx-document-viewer-empty-view-placeholder">
        <div class="empty-view-icon" phx-icon [size]="64" [phxIcon]="ImageIcon"></div>
        <p class="phx-web-type-body-small">{{message}}</p>
      </div>
    </ng-template>
    <div class="phx-document-viewer-floating-buttons-container"
      [ngClass]="{ 'phx-document-viewer-floating-buttons-disabled': !(selectedFile && !selectedFile?.error) || phxObfuscate }">
      <phx-button-group>
        <button phx-icon-button [phxIconButtonSize]="'small'" [phxIcon]="ZoomOutIcon" (click)="handleZoomOut()"
          [disabled]="!(selectedFile && !selectedFile?.error) || phxObfuscate"></button>
        <button phx-icon-button [phxIconButtonSize]="'small'" [phxIcon]="ZoomInIcon" (click)="handleZoomIn()"
          [disabled]="!(selectedFile && !selectedFile?.error) || phxObfuscate"></button>
        <ng-container *ngIf="isImageSelected">
          <div class="phx-document-viewer-floating-buttons-container-divider">
            <phx-divider phxOrientation="vertical"></phx-divider>
          </div>
          <button phx-icon-button [phxIconButtonSize]="'small'" [phxIcon]="RotateIcon" (click)="handleRotation(-90)"
            [disabled]="!(selectedFile && !selectedFile?.error) || phxObfuscate"></button>
        </ng-container>
        <div class="phx-document-viewer-floating-buttons-container-divider">
          <phx-divider phxOrientation="vertical"></phx-divider>
        </div>
        <button phx-icon-button [phxIconButtonSize]="'small'" [phxIcon]="DownloadIcon" (click)="handleDownload()"
          [disabled]="!(selectedFile && !selectedFile?.error) || phxObfuscate"></button>
      </phx-button-group>
    </div>
  </div>
  <div class="phx-document-viewer-file-upload-container">
    <phx-file-upload [phxFiles]="files" [phxEditMode]="phxEditMode" [phxLayout]="layout" [phxMultiple]="phxMultiple"
      [phxActiveFile]="selectedFile" [phxObfuscate]="phxObfuscate" (phxFilesChange)="filesChange($event)"
      [phxUploadOnSelect]="phxUploadOnSelect" [phxFileMaxSize]="phxFileMaxSize"
      [phxUploadURLProvider]="phxUploadURLProvider" [phxFileUploadLimit]="phxFileUploadLimit"
      (phxFileClicked)="onFileClicked($event)" (phxFileSelected)="onFileSelection($event)"
      (phxDeleteFile)="onFileDelete($event)" (phxFileError)="onFileError($event)"
      (phxUploadComplete)="onUploadComplete($event)"></phx-file-upload>
  </div>
</div>
